import { Twitter, Github, Linkedin } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="footer" className="relative bg-[#09090B] border-t border-white/5 pt-20 pb-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 bg-[#D4FF00] flex items-center justify-center rounded-sm">
                <span className="font-display text-black text-sm">ID</span>
              </div>
              <span className="font-display uppercase tracking-tight text-sm">
                Influence<span className="text-[#D4FF00]">Detector</span>
              </span>
            </div>
            <p className="mt-4 text-sm text-[#A1A1AA] max-w-sm">
              Find the creators hiding in your customer list. Works with Shopify, WooCommerce, BigCommerce, Wix, Squarespace, Magento, and any custom store via our API.
            </p>
            <div className="mt-6 hidden">
              {[Twitter, Linkedin, Github].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label="social"
                  data-testid={`footer-social-${i}`}
                  className="w-9 h-9 flex items-center justify-center border border-white/10 rounded-sm text-[#A1A1AA] hover:text-[#D4FF00] hover:border-[#D4FF00] transition-colors"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="text-[10px] tracking-[0.24em] uppercase text-white/40 font-semibold mb-4">
              Product
            </p>
            <ul className="space-y-3 text-sm text-[#A1A1AA]">
              <li><a href="#features" className="hover:text-white">Features</a></li>
              <li><a href="#how" className="hover:text-white">How it works</a></li>
              <li><a href="#pricing" className="hover:text-white">Pricing</a></li>
              <li><a href="#faq" className="hover:text-white">FAQ</a></li>
            </ul>
          </div>

          <div>
            <p className="text-[10px] tracking-[0.24em] uppercase text-white/40 font-semibold mb-4">
              Company
            </p>
            <ul className="space-y-3 text-sm text-[#A1A1AA]">
              <li><a href="#waitlist" className="hover:text-white">Waitlist</a></li>
              <li><a href="/privacy" className="hover:text-white">Privacy</a></li>
              <li><a href="/terms" className="hover:text-white">Terms</a></li>
              <li><a href="mailto:hello@influencedetector.com" className="hover:text-white">Contact</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-20 flex flex-col md:flex-row items-center justify-between pt-8 border-t border-white/5 text-xs text-[#A1A1AA] gap-3">
          <p>© {year} InfluenceDetector. All rights reserved.</p>
          <p className="font-mono-id">v1.0 · For every e-commerce platform</p>
        </div>

        {/* Massive brand text */}
        <div className="mt-16 text-center overflow-hidden">
          <div className="font-display uppercase outline-text text-[22vw] leading-[0.85] select-none">
            INFLUENCE<br />DETECTOR
          </div>
        </div>
      </div>
    </footer>
  );
}
